import { X, User, Mail, LogOut } from "lucide-react";
import type { Session } from "@supabase/supabase-js";
import type { UserProfile } from "../types";

type TFunc = (key: string) => string;

export function AccountSettings({ open, session, userProfile, onClose, onSignOut, t, dir }: {
  open: boolean;
  session: Session | null;
  userProfile: UserProfile | null;
  onClose: () => void;
  onProfileSaved: (p: UserProfile) => void;
  onSignOut: () => void;
  t: TFunc;
  dir: "rtl" | "ltr";
}) {
  if (!open) return null;
  const isAr = dir === "rtl";

  return (
    <div dir={dir} className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose}>
      <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-3xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="bg-gradient-to-br from-[#0A2240] to-[#0E3360] px-5 py-5 flex items-center justify-between">
          <h2 className="text-white font-bold text-lg">{isAr ? "إعدادات الحساب" : "Account settings"}</h2>
          <button onClick={onClose} className="w-8 h-8 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-white transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-5 space-y-4">
          {session && (
            <div className="space-y-3">
              <div className="flex items-center gap-3 p-3 rounded-xl bg-stone-50 dark:bg-slate-800">
                <div className="w-10 h-10 rounded-full bg-blue-100 dark:bg-blue-500/20 flex items-center justify-center">
                  <Mail className="w-5 h-5 text-blue-600" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-xs text-stone-400 dark:text-slate-500">{isAr ? "البريد الإلكتروني" : "Email"}</p>
                  <p className="text-sm font-medium text-stone-800 dark:text-slate-200 truncate">{session.user.email}</p>
                </div>
              </div>
              {userProfile && (
                <div className="flex items-center gap-3 p-3 rounded-xl bg-stone-50 dark:bg-slate-800">
                  <div className="w-10 h-10 rounded-full bg-green-100 dark:bg-green-500/20 flex items-center justify-center">
                    <User className="w-5 h-5 text-green-600" />
                  </div>
                  <div className="min-w-0 flex-1">
                    <p className="text-xs text-stone-400 dark:text-slate-500">{isAr ? "الملف الشخصي" : "Profile"}</p>
                    <p className="text-sm font-medium text-stone-800 dark:text-slate-200">
                      {userProfile.gender === "male" ? (isAr ? "ذكر" : "Male") : (isAr ? "أنثى" : "Female")} · {userProfile.age} {isAr ? "سنة" : "yr"} · {userProfile.weight_kg} kg
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}
          <button
            onClick={onSignOut}
            className="w-full py-3.5 rounded-xl bg-red-50 dark:bg-red-500/10 hover:bg-red-100 dark:hover:bg-red-500/20 text-red-600 dark:text-red-400 font-bold text-sm transition-all flex items-center justify-center gap-2"
          >
            <LogOut className="w-4 h-4" />
            {t("signOutThisDevice")}
          </button>
        </div>
      </div>
    </div>
  );
}
